import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';
import { DockPosition } from 'src/app/services/window-manager';

@Component({
    selector: 'app-widget-titlebar',
    templateUrl: './widget-titlebar.component.html',
    styleUrls: ['./widget-titlebar.component.scss', '_widget-titlebar-theme.scss'],
    standalone: false
})
export class WidgetTitlebarComponent {
  @HostBinding('class.code') @Input() code: boolean = false;
  @Input() restorable: boolean = true;
  @Input() closable: boolean = true;
  @Input() dockable: boolean = true;
  @Input() title: string = null;
  @Input() subtitle: string = null;
  @Input() isDirty: boolean = false;
  @Input() isMaximized: boolean = false;
  @Input() isDocked: boolean = false;

  @Output() onClose = new EventEmitter<void>();
  @Output() onRestore = new EventEmitter<void>();
  @Output() onMaximize = new EventEmitter<void>();
  @Output() onDock = new EventEmitter<DockPosition>();
  @Output() onUndock = new EventEmitter<void>();

  public showDockMenu = false;

  public get isDesktopEnvironment(): boolean {
    return this._settings.desktopEnvironment;
  }

  constructor(private readonly _settings: SettingsService) {}

  public toggleDockMenu(): void {
    this.showDockMenu = !this.showDockMenu;
  }

  public dockTo(position: DockPosition): void {
    console.log('WidgetTitlebar.dockTo called with position:', position);
    this.showDockMenu = false;
    this.onDock.emit(position);
  }
}
